import { Injectable, Inject, InjectionToken, DOCUMENT } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { EnvironmentConfigurationService } from '@nimbus-library/features/configuration';
import {
  PermissionError,
  GraphApiAppPermissionError,
} from '@nimbus-library/features/shared/models/api/graph-api-permission-exception.model';
import { GraphApiPermissionError } from '@nimbus-library/features/shared/models/api/grapi-api-permission-errors.enum';
import { IErrorStatus } from '@nimbus-library/features/shared/models/interfaces';

export const DEFAULT_ADMIN_CONSENT_REDIRECTURI = new InjectionToken<string>('defaultAdminConsentRedirectUri');

@Injectable()
export class PermissionErrorHandlerService {
  public constructor(
    @Inject(DOCUMENT) private readonly document: Document,
    @Inject(DEFAULT_ADMIN_CONSENT_REDIRECTURI) private readonly defaultAdminConsentUri: string,
    private readonly environmentService: EnvironmentConfigurationService,
  ) {}

  public handle(httpError: IErrorStatus | HttpErrorResponse): HttpErrorResponse | IErrorStatus | PermissionError {
    if (
      ((httpError instanceof HttpErrorResponse && httpError.status === 403) || (httpError as any).httpStatus === 403) &&
      httpError.error
    ) {
      try {
        const error: GraphApiAppPermissionError = typeof httpError.error === 'string' ? JSON.parse(httpError.error) : httpError.error;

        if (error && error.Code && error.Exception) {
          const permissionError = new PermissionError();
          permissionError.code = error.Code as GraphApiPermissionError;
          permissionError.applicationId = error.Exception.ApplicationId;
          permissionError.consentLink = this.getAdminConsentLink(error.Exception.ApplicationId, error.Exception.TenantId);
          permissionError.message = error.Exception.Message;
          permissionError.tenantId = error.Exception.TenantId;

          return permissionError;
        } else {
          return httpError;
        }
      } catch (err) {
        return httpError;
      }
    } else {
      return httpError;
    }
  }

  public getAdminConsentLink(applicationId: string, tenantId: string) {
    const redirectUrl = `${this.document.location.protocol}//admin.${this.environmentService.configurationSettings.mainLocation}/${this.defaultAdminConsentUri}`;

    return `https://login.microsoftonline.com/${tenantId}/adminConsent?client_id=${applicationId}&redirect_uri=${redirectUrl}`;
  }
}
